import type { ReactElement } from 'react'

/**
 * Last-resort UI when a render throws and the top-level Sentry ErrorBoundary
 * catches it. Before this existed a render crash left a blank white page.
 *
 * Deliberately imports nothing but React and uses only design tokens: a
 * fallback that pulls in the component library can fail for the same reason the
 * app just did, and then there is nothing to show at all. Keep it that way.
 */
export function AppErrorFallback(): ReactElement {
  return (
    <div className="grid min-h-screen place-items-center bg-surface px-6">
      <div className="max-w-md space-y-3 text-center">
        <h1 className="text-lg font-medium text-ink">Something went wrong</h1>
        <p className="text-sm text-ink-muted">
          This page hit an unexpected error. It has been reported. Reloading usually clears it.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="mt-2 rounded-md border border-line px-3 py-1.5 text-sm font-medium text-ink hover:bg-surface-hover"
        >
          Reload
        </button>
      </div>
    </div>
  )
}
